/*
  Formulaire de contact : vérifie les champs obligatoires avant l'envoi et affiche le message d'erreur du champ.
  Un champ est obligatoire quand son conteneur .field-wrapper porte data-required="true".
*/
if (!customElements.get('contact-form')) {
  customElements.define(
    'contact-form',
    class ContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.form.setAttribute('novalidate', 'novalidate');
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.form.addEventListener('input', (event) => this.clearError(event.target.closest('.field-wrapper')));
      }

      onSubmit(event) {
        let firstInvalid = null;
        this.querySelectorAll('.field-wrapper[data-required="true"]').forEach((wrapper) => {
          const input = wrapper.querySelector('input, textarea');
          if (!input) return;
          const empty = input.value.trim() === '';
          const invalid = empty || !input.checkValidity();
          this.setError(wrapper, input, invalid);
          if (invalid && !firstInvalid) firstInvalid = input;
        });
        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
        }
      }

      setError(wrapper, input, invalid) {
        const message = wrapper.querySelector('.field-wrapper__error-msg');
        if (message) message.classList.toggle('hidden', !invalid);
        if (invalid) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }

      clearError(wrapper) {
        if (!wrapper) return;
        const input = wrapper.querySelector('input, textarea');
        if (input && input.value.trim() !== '' && input.checkValidity()) this.setError(wrapper, input, false);
      }
    }
  );
}
